import React from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';

// GLOBAL COMPONENTS
import Card from 'parts/card/Card';
import Main from 'parts/main/Main';
import Page from 'parts/page/Page';
import Title from 'parts/title/Title';

// MAIN COMPONENT
const ChangePassword = () => {
  return (
    <Main>
      <Title documentTitle="Change Password" title="Change Password" />
      <Form
        endpoint={ENDPOINTS.user.password}
        loadingMessage="Updating password"
        successMessage="Password udpated."
        errorMessage="Unable to update password."
      >
        <Card body={<Form.Body>
          <Form.Control
            type="password"
            name="currPassword"
            label="Old Password"
            required
          />
          <Form.Control
            name="newPassword"
            label="New Password"
            confirmationProps={{
              name: 'confPassword',
              label: 'Confirm Password'
            }}
            showButton
            required
          />
        </Form.Body>} />
        <Page.Buttons>
          <Button.Submit label="Save New Password" icon="checkmark" />
        </Page.Buttons>
      </Form>
    </Main>
  );
};

// EXPORT
export default ChangePassword;
